import React from "react";
import { localize, shorten } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";

import Tooltip from ".";

interface IProps {
  locale: Locale;
  size: number;
  label: string;
  color: string;
  XMetricLabel: string;
  YMetricLabel: string;
  xValue: number | string;
  yValue: number;
  sizeMetricLabel?: string;
}

function getLocalizeNumber(locale: Locale, count: number) {
  if (count > 100000) {
    return shorten(locale, count);
  } else {
    return localize(locale, count);
  }
}

const TooltipBubble = ({
  locale,
  size,
  label,
  color,
  XMetricLabel,
  YMetricLabel,
  sizeMetricLabel,
  xValue,
  yValue,
}: IProps) => {
  return (
    <Tooltip
      label={label}
      color={color}
      content={
        sizeMetricLabel && (
          <>
            {sizeMetricLabel}: {getLocalizeNumber(locale, size)}
          </>
        )
      }
      footer={
        <>
          <div>
            {XMetricLabel}: {xValue}
          </div>
          <div>
            {YMetricLabel}: {shorten(locale, yValue)}
          </div>
        </>
      }
    />
  );
};

export default TooltipBubble;
